<template>
    <Dialog title="Edit Organization Member" :show="isOpen" :onClose="onCancel">
        <el-form :model="item" label-width="180px" label-position="left" size="small" ref="formRef">
            <el-form-item label="Email">
                <el-input v-model="item.email" readonly disabled />
            </el-form-item>
            <el-form-item label="Access Level">
                <el-select v-model="item.access_level">
                    <el-option value="none" label="none" />
                    <el-option value="member" label="member" />
                    <el-option value="admin" label="admin" />
                </el-select>
            </el-form-item>
            <el-divider></el-divider>
            <el-row type="flex" justify="center">
                <el-button type="primary" size="small" @click="save">Save</el-button>
                <el-button size="small" @click="cancel">Cancel</el-button>
            </el-row>
        </el-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/Dialog";

export default {
    props: {
        item: {
            type: Object,
            default: () => { },
        },
        isOpen: Boolean,
        onCancel: Function,
        onSave: Function,
    },
    components: {
        Dialog,
    },
    methods: {
        save() {
            this.$refs.formRef.validate(async (valid) => {
                if (!valid) {
                    return;
                }
                this.onSave(this.item);
            });
        },
        cancel() {
            this.onCancel();
        },
    },
};
</script>

<style scoped></style>